const MS_PER_MINUTE = 60_000;

/** Total inactivity window before forced logout. */
export const SESSION_TOTAL_MINUTES = 10;
export const SESSION_TOTAL_MS = SESSION_TOTAL_MINUTES * MS_PER_MINUTE;

/** Idle period before the warning dialog appears. */
export const SESSION_IDLE_MINUTES = 8;
export const SESSION_IDLE_MS = SESSION_IDLE_MINUTES * MS_PER_MINUTE;

/** Warning countdown duration after idle threshold. */
export const SESSION_WARNING_MINUTES = 2;
export const SESSION_WARNING_MS = SESSION_WARNING_MINUTES * MS_PER_MINUTE;

export const SESSION_IDLE_SECONDS = SESSION_IDLE_MS / 1000;
export const SESSION_WARNING_SECONDS = SESSION_WARNING_MS / 1000;

/** Refresh access token this many ms before JWT expiry. */
export const SESSION_REFRESH_BEFORE_MS = 300_000;

export const SESSION_LAST_ACTIVITY_KEY = 'lastActivity';
/** One-time logout reason shown on the login page (not passed in the URL). */
export const SESSION_LOGOUT_REASON_KEY = 'logoutReason';
export const SESSION_BROADCAST_CHANNEL = 'inactivity';

export type SessionState = 'active' | 'warning' | 'timedout';
export type SessionLogoutReason = 'inactivity' | 'expired' | 'forbidden';
